function formatPriceForApi(price){
    let temValue = price.replace(/\./g, "");
    return temValue.replace(",", '.');
}

export default formatPriceForApi;